export default "__VITE_ASSET__Dbw2cpC2__"